import { AuLabelsProvider } from '@au/ui';
import { useLingui } from '@lingui/react';
import { useMemo } from 'react';
import type { ReactNode } from 'react';
import { buildAuLabels } from './au-labels';

/**
 * Monta el catálogo de `@au` en el idioma activo. Se arma de nuevo **solo** al cambiar de idioma: la
 * identidad del objeto es el valor del contexto, y uno nuevo re-renderiza a todo lo que lee textos.
 */
export function AppAuLabelsProvider({ children }: { children: ReactNode }) {
  const { i18n } = useLingui();
  const locale = i18n.locale;
  // `locale` es la dependencia a propósito: `i18n` es un objeto único que no cambia de identidad.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const labels = useMemo(() => buildAuLabels(i18n), [locale]);

  return <AuLabelsProvider labels={labels}>{children}</AuLabelsProvider>;
}
